import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-71c8ebe6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-item-container" }
const _hoisted_2 = { class: "form-item-header" }
const _hoisted_3 = { class: "question" }
const _hoisted_4 = {
  key: 0,
  class: "faces-item-body"
}
const _hoisted_5 = { class: "overall-info-container" }
const _hoisted_6 = { class: "font-weight-black pr-1" }
const _hoisted_7 = { class: "all-faces-container" }
const _hoisted_8 = { class: "percentage-count-container pt-2" }
const _hoisted_9 = { class: "response-count" }
const _hoisted_10 = { class: "percentage" }
const _hoisted_11 = { class: "submission-info-container" }
const _hoisted_12 = {
  key: 1,
  class: "stars-item-body"
}
const _hoisted_13 = { class: "stats-summary" }
const _hoisted_14 = { class: "text-h3 font-weight-black text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-h6 ml-n3" }, "/5", -1))
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "stats-detailed" }
const _hoisted_18 = { class: "stats-detailed-label" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "stats-detailed-bars"
}
const _hoisted_21 = {
  key: 1,
  class: "stats-detailed-numbers"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        class: "gorate-bg cursor-default",
        icon: _ctx.getFormItemIconIndex,
        height: "30",
        variant: "text",
        width: "30"
      }, null, 8, ["icon"]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formItem.question_lang1), 1)
    ]),
    (_ctx.getRatingTypeName(_ctx.formItem.rating_type_id) === 'FACES' && _ctx.isFaceRatingDetail)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('i18n.overall')) + ":", 1),
            _createTextVNode(_toDisplayString(_ctx.getAverageFacePercentage()) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFacesVoteDistribution(), (singleFaceStats, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "single-face-container",
                key: index
              }, [
                _createVNode(_component_v_progress_circular, {
                  "model-value": singleFaceStats.percentage,
                  rotate: 360,
                  size: 60,
                  width: 4,
                  color: _ctx.getFaceColor(index)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getEmoticon(index))))
                  ]),
                  _: 2
                }, 1032, ["model-value", "color"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(singleFaceStats.response_count), 1),
                  _createElementVNode("div", _hoisted_10, "(" + _toDisplayString(singleFaceStats.percentage.toFixed(1)) + "%)", 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('i18n.submissions')) + ": " + _toDisplayString(_ctx.getTotalResponses(_ctx.formItemIndex - 1)), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.getRatingTypeName(_ctx.formItem.rating_type_id) === 'STARS')
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.getFormItemAvgRate(_ctx.formItemIndex - 1)) + " ", 1),
              _hoisted_15
            ]),
            _createVNode(_component_v_rating, {
              class: "star-rating mb-1",
              "model-value": _ctx.getFormItemAvgRate(_ctx.formItemIndex - 1),
              size: 22,
              color: "yellow-darken-3",
              "half-increments": "",
              readonly: ""
            }, null, 8, ["model-value"]),
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getTotalResponses(_ctx.formItemIndex - 1)) + " " + _toDisplayString(_ctx.$t('i18n.submissions')), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(_ctx.getRatingTypeStepsNumber(_ctx.formItem.rating_type_id)).keys()].reverse(), (step) => {
                return (_openBlock(), _createElementBlock("div", { key: step }, [
                  _createTextVNode(_toDisplayString(step + 1) + " " + _toDisplayString(_ctx.$t('i18n.star')), 1),
                  ((step + 1) > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "s"))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]),
            (_ctx.isStarRatingDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reversedStarsVoteDistribution(), ([starNumber, numberOfVotes]) => {
                    return (_openBlock(), _createElementBlock("div", { key: starNumber }, [
                      _createVNode(_component_v_progress_linear, {
                        color: "#ffd139",
                        rounded: "",
                        max: _ctx.getTotalResponses(_ctx.formItemIndex - 1),
                        "model-value": numberOfVotes,
                        height: 8
                      }, null, 8, ["max", "model-value"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isStarRatingDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reversedStarsVoteDistribution(), ([starNumber, numberOfVotes]) => {
                    return (_openBlock(), _createElementBlock("div", { key: starNumber }, _toDisplayString(numberOfVotes) + " " + _toDisplayString(_ctx.getStarPercentage(numberOfVotes, _ctx.formItemIndex - 1)), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}